import { useState, useEffect } from "react";
import makeApi, { URLS } from "Utils/apiURL";
import Utils from "Utils/utils";

// SG-2164: same API + response shape as the global member/team filter (see
// Dashboard/reports/UserFilterDropdown.js's getTeamMemberList) — GET /cm/team/filterDetails,
// response.data.groups: [{ group: {id, name}, members: [{memberId, firstName, lastName, email}] }].
// Shared by AudienceScopePopover and ConfigureWidgetPanel so both use the identical source of truth.
const useTeamMembersAndTeams = () => {
  const [members, setMembers] = useState([]);
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    makeApi({ url: URLS.getTeamData, method: "GET" })
      .then(res => {
        if (cancelled) return;
        const groups = res?.data?.groups || [];
        const allMembers = [];
        const allTeams = [];
        groups.forEach(item => {
          const { group = {}, members: groupMembers = [] } = item || {};
          if (group?.id) {
            allTeams.push({ id: group.id, name: group.name });
          }
          groupMembers.forEach(m => {
            if (m?.memberId && !allMembers.some(existing => existing.memberId === m.memberId)) {
              allMembers.push({ memberId: m.memberId, name: Utils.getFullNameFromUserInfo(m) });
            }
          });
        });
        setMembers(allMembers);
        setTeams(allTeams);
      })
      .catch(err => console.error("useTeamMembersAndTeams: failed to load team members", err))
      .finally(() => !cancelled && setLoading(false));
    return () => { cancelled = true; };
  }, []);

  return { members, teams, loading };
};

export default useTeamMembersAndTeams;
